import { EmailsThemeDto } from "@babackapp/private-api-client/types";
import { calculateContrastColor, getContrastText } from "@babackapp/ui/lib/colors";

export type ThemeContextParent =
  | "background"
  | "card"
  | "primary"
  | "secondary";


export function sectionToParent(section: 'before' | 'after' | 'inside'): ThemeContextParent {
  if (section === 'inside') return 'card';
  return 'background';
}


const DEFAULT_COLORS = {
  background: "#f0f0f0",
  card: "#ffffff",
  primary: "#000000",
  secondary: "#000000",
};

export function useThemeContextualColors(theme: EmailsThemeDto | null | undefined, parent: ThemeContextParent) {
  const bg = theme?.backgroundColor ?? DEFAULT_COLORS.background;
  const card = theme?.cardColor ?? DEFAULT_COLORS.card;
  const primary = theme?.primaryColor ?? DEFAULT_COLORS.primary;
  const secondary = theme?.secondaryColor ?? DEFAULT_COLORS.secondary;

  // `text` must be a readable foreground (near-black / near-white) chosen for
  // contrast against the surface — use `getContrastText`, NOT
  // `calculateContrastColor` (the latter only nudges the color ~10%, which is a
  // border/stroke tone and renders as near-invisible gray text on a light card).
  // `contrast` stays on `calculateContrastColor`: it's the subtle border tone.
  const colorsMap = {
    background: {
      bg,
      text: theme?.backgroundTextColor ?? getContrastText(bg),
      contrast: calculateContrastColor(bg),
    },
    card: {
      bg: card,
      text: theme?.cardTextColor ?? getContrastText(card),
      contrast: calculateContrastColor(card),
    },
    primary: {
      bg: primary,
      text: theme?.primaryTextColor ?? getContrastText(primary),
      contrast: calculateContrastColor(primary),
    },
    secondary: {
      bg: secondary,
      text: theme?.secondaryTextColor ?? getContrastText(secondary),
      contrast: calculateContrastColor(secondary),
    },
  }

  return colorsMap[parent];
}

export default useThemeContextualColors;
